const Style = `
  <style>
    .customization-details-wrapper {
      overflow: auto;
      padding: 10px 20px 30px 20px
    }

    .customization-title-wrapper {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 5px;
    }

    .buttons-wrapper {
      display: flex;
      justify-content: space-between;
      gap: 20px;
    }

    .cta {
      width: 50%;
    }

    .cta-2 {
      border-color: black;
      cursor: pointer;
    }

    .cta-2:hover {
      background-color: #d2eae5;
      border-color: #d2eae5;
      color: #000;
    }

    input {
      height: 33px;
      width: 217px;
      border-radius: 9px;
      padding-left: 19px;
      border: 1px solid black;
      margin-bottom: 20px;
    }

    h2 {
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 0.54px;
      margin: 10px 0;
      margin-bottom: 30px;
    }

    h3 {
      font-size: 18px;
      font-weight: normal;
      letter-spacing: 0.54px;
      margin: 10px 0;
    }

    hr {
      border: 1px solid #f6f4f4;
    }

    .current-selection {
      font-size: 14px;
      color: #717575;
    }

    .error {
      font-size: 12px;
      color: #CE5347;
    }

    .error-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 17px;
      background: #EC6D62;
      border-radius: 50px;
      width: 32px;
      height: 32px;
      color: white;
      font-weight: bold;
    }
    
    .color-selector-wrapper {
      margin-bottom: 20px;
    }

    @media (max-width: 768px) {
      .buttons-wrapper {
        display: block;
      }

      .cta {
        width: 100%;
        margin-bottom: 10px;
      }
    }
  </style>
`;

export default Style;
